import { IconButton, Tooltip } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { useClassroomCapabilities } from '../../../../hooks/use-classroom-capabilities';
import { Classroom } from '../../../../modules/classroom';
import { OrganizationTeacher } from '../../../../modules/teacher';

function AssignClassroomsToTeacherUnlinkButton({
  classroom,
  teacher,
  onClassroomLeave,
}: {
  teacher: OrganizationTeacher | undefined;
  classroom: Classroom;
  onClassroomLeave: (classroom: Classroom) => void;
}): JSX.Element {
  const { t } = useTranslation();
  const {
    classroom: { canTeacherLeave },
  } = useClassroomCapabilities({ classroom });

  if (!teacher) return <></>;

  const canLeave = canTeacherLeave(teacher?.id);

  return (
    <Tooltip
      content={
        !canLeave ? t('manager.leave-classroom-rostered.warning') : undefined
      }
    >
      <IconButton
        icon="LeaveClassIcon"
        onClick={() => onClassroomLeave(classroom)}
        dataTestId="leave-classroom-button"
        state={!canLeave ? 'disabled' : undefined}
      />
    </Tooltip>
  );
}

export { AssignClassroomsToTeacherUnlinkButton };
